import GroupedRenderer from "./GroupedRenderer";

const FieldRenderer = ({
  question,
  value,
  onChange,
  isEditable
}) => {

  const schema =
    question.ui_schema || {};

  // =====================================
  // FILE CHANGE
  // =====================================

  const handleFileChange = (
    e
  ) => {

    const files =
      Array.from(
        e.target.files || []
      );

    const current =
      value || {};

    onChange(
      question.question_code,
      {
        ...current,
        evidence_files: files
      }
    );
  };

  // =====================================
  // BOOLEAN
  // =====================================



if (schema.type === "boolean") {

  return (

    <div className="brsr-boolean-wrapper">

      <label className="brsr-field-label">
        {schema.label}
      </label>

      <div className="brsr-radio-group">

        <label className="brsr-radio-option">

          <input
            type="radio"
            name={question.question_code}
            value="1"
            disabled={!isEditable}
            checked={
              value === 1 ||
              value === "1" ||
              value === true
            }
            onChange={() =>
              onChange(
                question.question_code,
                1
              )
            }
          />

          <span>Yes</span>

        </label>

        <label className="brsr-radio-option">

          <input
            type="radio"
            name={question.question_code}
            value="0"
            disabled={!isEditable}
            checked={
              value === 0 ||
              value === "0" ||
              value === false
            }
            onChange={() =>
              onChange(
                question.question_code,
                0
              )
            }
          />

          <span>No</span>

        </label>

      </div>

    </div>

  );
}
  // ============================
  // GROUPED
  // ============================

  if (schema.type === "grouped") {

    return (

      <GroupedRenderer
        question={question}
        value={value || {}}
        onChange={onChange}
        isEditable={isEditable}
      />

    );
  }

  // ============================
  // DERIVED
  // ============================

  if (
    question.input_type ===
    "derived"
  ) {

    return (

      <div className="brsr-field-wrapper">

        <input
          type="text"
          className="org-field-input"
          value={
            value !== null &&
            value !== undefined &&
            value !== ""
              ? Number(value).toFixed(2)
              : ""
          }
          readOnly
        />

      </div>

    );
  }

  // =====================================
  // TEXTAREA
  // =====================================

  if (
  schema.type === "textarea" ||
  schema.multiline === true
) {

    return (

      <div className="brsr-field-wrapper">

        <textarea
          rows={schema.rows || 4}
          className="org-field-input"
          placeholder={
            schema.placeholder
          }
          value={
            value?.text || ""
          }
          disabled={!isEditable}
          onChange={(e) =>
            onChange(
              question.question_code,
              {
                ...value,
                text: e.target.value
              }
            )
          }
        />

        {/* EVIDENCE */}

        {(
          schema.file_upload?.enabled ||
          schema.evidence?.enabled
        ) && (

          <div className="brsr-upload-wrapper">

            <input
              type="file"
              multiple
              disabled={!isEditable}
              accept={
                (
                  schema.file_upload
                    ?.accepted_types ||

                  schema.evidence
                    ?.allowed_types ||

                  []
                )
                  .map(
                    (t) => `.${t}`
                  )
                  .join(",")
              }
              onChange={(e) => {

  const files =
    Array.from(
      e.target.files || []
    );

  const currentValue =
    typeof value === "object" &&
    value !== null
      ? value
      : {};

  onChange(
    question.question_code,
    {
      ...currentValue,

      text:
        currentValue.text || "",

      evidence_files:
        files
    }
  );
}}
            />
{value?.existing_evidence
  ?.length > 0 && (

  <div className="brsr-existing-files">
<strong>Uploaded Evidence:</strong>
    {value.existing_evidence.map(
      (file, index) => (

        <a
          key={index}
          href={file.file_url}
          target="_blank"
          rel="noreferrer"
          className="brsr-existing-file"
        >
          📎 {file.file_name}
        </a>

      )
    )}

  </div>

)}
          </div>

        )}

      </div>

    );
  }

  // =====================================
  // INPUT
  // =====================================

  return (

    <div className="brsr-field-wrapper">

      <input
        type={
          schema.type || "text"
        }
        min={schema.min}
        className="org-field-input"
        placeholder={
          schema.placeholder
        }
        disabled={!isEditable}
        value={value ?? ""}
        onChange={(e) =>
          onChange(
            question.question_code,
            e.target.value
          )
        }
      />

      {/* EVIDENCE */}

      {(
        schema.file_upload?.enabled ||
        schema.evidence?.enabled
      ) && (

        <div className="brsr-upload-wrapper">

          <input
            type="file"
            multiple
            disabled={!isEditable}
            accept={
              (
                schema.file_upload
                  ?.accepted_types ||

                schema.evidence
                  ?.allowed_types ||

                []
              )
                .map(
                  (t) => `.${t}`
                )
                .join(",")
            }
            onChange={
              handleFileChange
            }
          />

        </div>

      )}

    </div>

  );
};

export default FieldRenderer;